import { formatTime } from "@/lib/generation-utils";

interface GenerationProgressProps {
  progress: number;
  timeRemaining: number | null;
}

export function GenerationProgress({
  progress,
  timeRemaining,
}: GenerationProgressProps) {
  return (
    <>
      {/* Progress Bar */}
      <div className="mb-4">
        <div className="h-1.5 rounded-full bg-white/[0.1] overflow-hidden">
          <div
            className="h-full rounded-full bg-gradient-to-r from-violet-500 to-purple-500 transition-all duration-1000 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Timer */}
      <div className="flex flex-col items-center justify-center gap-2 text-[#888] mb-8">
        <span className="text-sm">
          {timeRemaining !== null && timeRemaining > 0
            ? `Estimated time: ${formatTime(timeRemaining)}`
            : "Almost done..."}
        </span>
        {timeRemaining !== null && timeRemaining <= 0 && (
          <span className="text-xs text-amber-400/80 mt-1">
            High traffic — generation times may be longer than usual
          </span>
        )}
      </div>
    </>
  );
}
